<h1 mat-dialog-title>{{ 'LABEL.VERIFICA_DATI_SOGGETTO_PRATICA' | translate }}</h1>
<div mat-dialog-content>
  
  <p>{{ 'LABEL.SOGGETTO_DELLA_PRATICA' | translate }}</p>
  <p>
    <strong>{{ 'LABEL.FIRST_NAME' | translate }}:</strong> {{ data?.subject?.name || '-' }}<br>
    <strong>{{ 'LABEL.LAST_NAME' | translate }}:</strong> {{ data?.subject?.surname || '-' }}<br>
    <strong *ngIf="data?.subject?.legalEntity">{{ 'LABEL.LEGAL_ENTITY' | translate }}:</strong> {{ data?.subject?.legalEntity || '-' }}<br>
    <strong>{{ 'LABEL.EMAIL' | translate }}:</strong> {{ data?.subject?.email || '-' }}
  </p>

  <p><strong>{{ 'LABEL.CHECK_AND_UPDATE_INFO_BEFORE_SAVING' | translate }}</strong></p>

  <form [formGroup]="form" class="form-container">
      <mat-form-field appearance="fill" class="form-subject">
      <mat-label>{{ 'LABEL.TOT_ADMIN_CONDOMINIUMS' | translate }}</mat-label>
      <input matInput type="number" [placeholder]="'LABEL.INSERISCI_NUMERO_CONDOMINI_AMMINISTRATI' | translate"
        formControlName="totAdministeredCondominiums">
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">{{ "LABEL.CANCEL" | translate }}</button>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="!form.valid">{{ "LABEL.SAVE" | translate }}</button>
</div>